var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoIconOnly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 11.417v14.09h-8.837v-14.09H32zM18.744 0v36.923L8.87 34.217v-8.71H0v-14.09h8.837v-8.71l9.908-2.707zM17.07 18.478c0-.495-.234-.924-.535-.924-.301 0-.536.43-.536.924 0 .495.235.924.536.924.301-.033.535-.43.535-.924z",
    fill: "#6CC"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAzMiAzNyIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zMiAxMS40MTY2VjI1LjUwNjVIMjMuMTYzM1YxMS40MTY2SDMyWk0xOC43NDQxIDBWMzYuOTIzMUw4Ljg2OTQ3IDM0LjIxN1YyNS41MDY1SDBWMTEuNDE2Nkg4LjgzNjczVjIuNzA2MDVMMTguNzQ0OSAwSDE4Ljc0NDFaTTE3LjA3MDIgMTguNDc3OUMxNy4wNzAyIDE3Ljk4MzIgMTYuODM2MSAxNy41NTQxIDE2LjUzNDkgMTcuNTU0MUMxNi4yMzM3IDE3LjU1NDEgMTUuOTk4OCAxNy45ODMyIDE1Ljk5ODggMTguNDc3OUMxNS45OTg4IDE4Ljk3MjcgMTYuMjMzNyAxOS40MDE4IDE2LjUzNDkgMTkuNDAxOEMxNi44MzYxIDE5LjM2OSAxNy4wNzAyIDE4Ljk3MjcgMTcuMDcwMiAxOC40Nzc5WiIgZmlsbD0iIzY2Q0NDQyIvPgo8L3N2Zz4K";
export { SvgLogoIconOnly as ReactComponent };